// apps/web/src/components/checklist/ReadingTimer.tsx
import { useState, useEffect, useRef } from 'react';

interface Props {
  minutes: number;
  active: boolean;
  onStart: () => void;
  onComplete: () => void;
}

export function ReadingTimer({ minutes, active, onStart, onComplete }: Props) {
  const [secondsLeft, setSecondsLeft] = useState(minutes * 60);
  const intervalRef = useRef<ReturnType<typeof setInterval> | null>(null);

  useEffect(() => {
    if (!active) return;

    intervalRef.current = setInterval(() => {
      setSecondsLeft(prev => {
        if (prev <= 1) {
          if (intervalRef.current) clearInterval(intervalRef.current);
          onComplete();
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => {
      if (intervalRef.current) clearInterval(intervalRef.current);
    };
  }, [active, onComplete]);

  const displayMinutes = Math.floor(secondsLeft / 60);
  const displaySeconds = secondsLeft % 60;
  const progress = ((minutes * 60 - secondsLeft) / (minutes * 60)) * 100;

  if (!active) {
    return (
      <button onClick={onStart} className="btn-timer-start">
        Start {minutes}-Minute Timer
      </button>
    );
  }

  return (
    <div className="reading-timer">
      <div className="timer-display">
        <span className="timer-time">
          {String(displayMinutes).padStart(2, '0')}:{String(displaySeconds).padStart(2, '0')}
        </span>
      </div>
      <div className="timer-bar">
        <div className="timer-bar-fill" style={{ width: `${progress}%` }} />
      </div>
      <p className="timer-hint">Keep reading! Timer is running.</p>
    </div>
  );
}
